export default "__VITE_ASSET__26b0c68f__"